import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';

import { Injectable, Inject } from 'ng-metadata/core';
import {SearchFieldsService} from "../search/search.fields.service";
import {getBackendSystem} from "../appConfig/appConfigForward";

@Injectable()
export class JournalsService {
    constructor(@Inject('$state') private $state:angular.ui.IStateService,
                private searchFieldsService: SearchFieldsService,
                @Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService) {

    }
    public isJournalSearch() {
        return (this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH ||
            this.$state.current.name ===STATE_NAMES.JOURNAL_FULL_DISPLAY);
    }
    public returnToJournalsSearch(){
      return this.searchFieldsService.tab === this.JOURNAL_SEARCH_TAB &&
          getBackendSystem() === 'suprima';
    }

    public get JOURNAL_SEARCH_TAB():string {return window.appConfig['journal_tab'] || 'jsearch_slot'; }

}







// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/journals.service.ts